import script from "./UMarkdownViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./UMarkdownViewer.vue?vue&type=script&setup=true&lang=ts"

import "./UMarkdownViewer.vue?vue&type=style&index=0&id=731dfb0b&scoped=true&lang=scss"
import "./UMarkdownViewer.vue?vue&type=style&index=1&id=731dfb0b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-731dfb0b"]])

export default __exports__